import ServiceBus from 'servicestack/service-bus'
import ModalController from 'webmodals/modal.controller'
import Design from 'emun.on-demand/lib/design'
import DesignLayer from 'emun.on-demand/lib/design-layer'
import resolve from 'ioc/resolve'

class DesignProductPromptController extends ModalController {
    constructor($uibModalInstance, options) {
        super($uibModalInstance)
        const $ctrl = this;
        $ctrl.bus = new ServiceBus();
        $ctrl.title = options.title || 'Design Product...';
        $ctrl.subTitle = options.subTitle;
        $ctrl.product = options.product;
        $uibModalInstance.closed.finally(() => $ctrl.designer.dispose());

        console.debug('DesignProductPromptController', options);
    }

    initializeDesigner(designer) {
        let $ctrl = this;
        $ctrl.designer = designer;
        designer.ready = false;
        designer.isLoading = true;
        designer.status = 'loading';
        designer.mode = 'Inline';
        //designer.editorPopoverPlacement = 'left-top';

        $ctrl.bus.send('QueryOnDemandProducts.json?IncludeInactive=true&ProductId=' + $ctrl.product.id).then(res => {
            Object.assign($ctrl.product, res.data.results[0]);
            designer.designs = [];
            $ctrl.product.areas.forEach(a => {
                let d = Design.fromArea(a, { productId: $ctrl.product.id });
                d.anythingGoes = true;
                designer.designs.push(d);
            });

            designer.activate(designer.designs[0]);
            designer.ready = true;
            designer.isLoading = false;
            designer.status = 'ready';
        });
    }

    submit() {
        const $ctrl = this;
        let designer = $ctrl.designer;
        let replacePredecessor = true;
        designer.status = 'rendering';

        return designer.save(replacePredecessor).then(() => {
            let req = {
                productId: $ctrl.product.id,
                areas: $ctrl.product.areas
            };
            return $ctrl.bus.send('UpdateProductDesign.json', req).then(res => $ctrl.close(res));
        }).finally(() => {
            designer.ready = true;
            designer.isLoading = false;
            designer.status = 'ready';
        });
    }

    $onDestroy() {
    }
}

export default DesignProductPromptController;